import React, { useEffect, useState } from "react";
import { validateEmail, validatePassword, validatePhone } from "../../../../utils";

function Input(props) {
  const { img, label, name, handleChange, value, submit, required,validation } = props;
  const [error, setError] = useState(false);
 
  const onChange = (event) => {
    const { name, value } = event.target
    // console.log("validateEmail(value)", validateEmail(value))


    handleChange(event)
  }


  useEffect(() => {
    if (submit) {
      if (validation === "email") {
        setError(!validateEmail(value,required))
      }
      else if (validation === "phone") {
        setError(!validatePhone(value,required))
      }
      else if (validation === "password") {
        // console.log("test password",validatePassword(value));
        
        setError(!validatePassword(value))
      }
      else if (validation === "required"){
        setError(value?.trim().length === 0)
      }
    }
  }, [submit])
  return (
    <>
      <span className="det-label">
        {img ?
          <img
            src={require(`../../../../assets/DigitalMarketing/image/customer/${img}.png`)}
            alt="i"
          /> : ''}
        {label}
      </span>
      {name === "phone" ?
        <input type="text" maxLength={10} placeholder="Empty" style={{ border: error && submit ? "1px solid red" : "" }} className="text-custom" value={value} name={name} onChange={onChange} />
        :
        <input type="text" placeholder="Empty" style={{ border: error && submit ? "1px solid red" : "" }} className="text-custom" value={value} name={name} onChange={onChange} />

      }
      {error&& validation==="password" &&
      <>
      <p style={{textAlign:"end",marginBottom:"0",fontSize:"12px",color:"red"}}>minimum 8 characters Required</p>
      </>
      }
    </>
  );
}

export default React.memo(Input);
